import { get, post } from '../utils/request2';
import IM from './config';
import './message';
import './replybody';
import './sentbody';

let socket;

const IMWebClient = {};
IMWebClient.config = IM; // 配置信息
IMWebClient.listeners = {}; // 用于存储事件监听器
IMWebClient.bindCount = 0; // 连接次数

/**
 * 创建 websocket 连接
 */
IMWebClient.connect = function () {
  socket = new WebSocket(IM.CIM_URI);
  socket.cookieEnabled = false;
  socket.binaryType = 'arraybuffer';
  socket.onopen = IMWebClient.innerOnConnectFinished;
  socket.onmessage = IMWebClient.innerOnMessageReceived;
  socket.onclose = IMWebClient.innerOnConnectClosed;
};

/**
 * 关闭 websocket 连接
 * 判断socket是否已创建并且它的状态不是"未连接"
 */
IMWebClient.stop = function () {
  if (!socket || socket.readyState !== 1) {
    return;
  }
  socket.close();
};

/**
 * SOCKET事件-连接成功时
 */
IMWebClient.innerOnConnectFinished = function () {
  IMWebClient.trigger('open');
};

/**
 * SOCKET事件-断开完成时
 */
IMWebClient.innerOnConnectClosed = function (e) {
  console.log('************* 连接关闭 Code:[' + e.code + '] *************');
  IMWebClient.trigger('close', e.code);
};

/**
 * SOCKET事件-接收事件消息时
 * @param e 消息内容
 */
IMWebClient.innerOnMessageReceived = function (e) {
  let data = new Uint8Array(e.data);
  let type = data[0];
  let body = data.subarray(IM.DATA_HEADER_LENGTH, data.length);
  // 心跳消息
  if (type === IM.PING) {
    IMWebClient.pong();
    return;
  }
  // 系统消息
  if (type === IM.REPLY_BODY) {
    let message = proto.com.farsunset.cim.sdk.web.model.ReplyBody.deserializeBinary(body);
    // 将proto对象转换成json对象，去除无用信息
    let reply = {};
    reply.code = message.getCode();
    reply.key = message.getKey();
    reply.message = message.getMessage();
    reply.timestamp = message.getTimestamp();
    reply.data = {};
    // 注意，遍历map这里的参数 value在前key在后
    message.getDataMap().forEach(function (v, k) {
      reply.data[k] = v;
    });

    reply.type = 'event';

    // 通知页面上的消息事件函数
    IMWebClient.trigger('message', reply);
    /*
     * 判断是否是握手鉴权失败
     * 终止后续自动重连
     */
    if (reply.key === IM.KEY_HANDSHAKE && reply.code === IM.CODE_UNAUTHORIZED) {
      return;
    }
    // 连接断开成功回调
    if (reply.key === IM.KEY_CLIENT_CLOSED && reply.code === IM.CODE_OK) {
      IMWebClient.stop();
    }
  }
  // 客户消息
  if (type === IM.MESSAGE) {
    let message = proto.com.connectnow.im.model.Message.deserializeBinary(body);
    let data = message.toObject(false);
    data.type = 'message';
    IMWebClient.trigger('message', data);
    return;
  }
};

/**
 * 发送sentBody类型消息
 * @param key   类型
 * @param params 请求参数
 */
function sendSentBody(key, params) {
  let body = new proto.com.farsunset.cim.sdk.web.model.SentBody();
  body.setKey(key);
  // 循环添加参数
  if (params) {
    const keys = Object.keys(params);
    keys.forEach((key) => {
      body.getDataMap().set(key, params[key]);
    });
  }
  body.setTimestamp(new Date().getTime());
  let data = body.serializeBinary();
  let protobuf = new Uint8Array(data.length + 1);
  protobuf[0] = IM.SENT_BODY;
  protobuf.set(data, 1);
  try {
    socket.send(protobuf);
  } catch (error) {
    console.error('发送消息失败', error);
  }
}

/**
 * 会话操作-创建会话联系人
 * @param params 用户信息 {tenantId：公司id、uid：用户id、username：用户名称、sessionId：会话id}
 */
IMWebClient.bindAccount = function (params) {
  let browser = getBrowser();
  let deviceId = window.localStorage.imChatDeviceId;
  if (deviceId === '' || deviceId === undefined) {
    deviceId = generateUUID();
    window.localStorage.imChatDeviceId = deviceId;
  }
  let key = IM.KEY_CLIENT_BIND;
  let data = {
    channel: IM.APP_CHANNEL,
    channelType: params.channelType, // 渠道类型区分客户是那个平台
    appVersion: IM.APP_VERSION,
    osVersion: browser.version,
    packageName: IM.APP_PACKAGE,
    deviceName: browser.name,
    deviceId: deviceId,
    language: navigator.language,
    role: IM.role,
    uid: params.uid,
    username: params.username,
    tenantId: params.tenantId,
    contactAttributes: params.contactAttributes,
    ticketAttr: params.ticketAttr,
    distributionRule: params.distributionRule, //用于aiagent连接客服选项
  };
  if (params.sessionId) {
    data.sessionId = params.sessionId;
  }
  sendSentBody(key, data);
};

/**
 * 会话操作-断开通话
 */
IMWebClient.disconnect = function (params) {
  if (!IMWebClient?.session || !IMWebClient?.session?.sessionId) {
    console.error('IMWebClient 信息异常', IMWebClient?.session);
    return;
  }
  let key = IM.KEY_CLIENT_CLOSED;
  let data = { tenantId: params.tenantId, sessionId: IMWebClient?.session?.sessionId, role: IM.role };
  sendSentBody(key, data);
};

/**
 * 会话操作-关闭ACW窗口
 */
IMWebClient.closeACW = function () {
  if (!IMWebClient?.session || !IMWebClient?.session?.sessionId) {
    console.error('IMWebClient 信息异常', IMWebClient?.session);
    return;
  }
  let key = IM.KEY_CLIENT_CLOSED;
  let data = { sessionId: IMWebClient?.session?.sessionId, acw: 'done' };
  sendSentBody(key, data);
};
IMWebClient.changeStatus = function (e) {
  let key = IM.KEY_CLIENT_CHANGE_STATUS;
  let data = {
    role: 'customer',
    sessionId: IMWebClient?.session?.sessionId,
    tenantId: e.tenantId,
    statusType: e.statusType,
  };
  sendSentBody(key, data);
};

IMWebClient.userInput = function (e) {
  if (!IMWebClient?.session || !IMWebClient?.session?.sessionId) {
    // console.error('IMWebClient 信息异常', IMWebClient.session);
    return;
  }
  let key = IM.KEY_CLIENT_USER_INPUT;
  let data = {
    type: 'be_inputting',
    sessionId: IMWebClient?.session?.sessionId,
    role: 'customer',
  };
  sendSentBody(key, data);
};

IMWebClient.offlineMessage = function (params) {
  let key = IM.KEY_CLIENT_SYSTEM_EVENT;
  let data = {
    type: 'offline_message',
    tenantId: params.tenantId,
    sessionId: IMWebClient?.session?.sessionId,
    role: 'customer',
    uid: params.uid,
  };
  sendSentBody(key, data);
};
IMWebClient.Rate = function (params) {
  let data = {
    sessionId: IMWebClient?.session?.sessionId,
    starCount: params.starCount,
    uid: params.uid,
    type: 'customer_evaluation',
  };
  sendSentBody('client_system_event', data);
};
/**
 * 发送心跳事件消息
 */
IMWebClient.pong = function () {
  let pong = new Uint8Array(IM.PONG_BODY.byteLength + 1);
  pong[0] = IM.PONG;
  pong.set(IM.PONG_BODY, 1);
  socket.send(pong);
};

/**
 * 发送消息请求
 * @param e 消息参数
 * @returns {Promise<void>}
 */
IMWebClient.send = async function (e) {
  if (!IMWebClient?.session || !IMWebClient?.session?.sessionId) {
    console.error('IMWebClient 信息异常', IMWebClient.session);
    return;
  }
  let params = {
    sessionId: IMWebClient?.session?.sessionId,
    role: IM.role,
    tenantId: e.tenantId,
    contentType: e.contentType,
    content: e.content,
    attachmentName: e.attachmentName || '',
    ticketAttr: e.ticketAttr,
    starCount: e.starCount,
    uid: e.uid,
    workRecordFileList: e.workRecordFileList || [],
  };
  // let url = IM.API_HOST + '/message/V2/send';
  let url = IM.API_HOST + '/message/send';
  post(url, params);
};

/**
 * 获取排队人数
 * @param tenantId 公司id
 */
IMWebClient.waitCustomerCount = function (tenantId, sessionId) {
  let url = 'https://' + process.env.API_HOST + '/api/crm/distribution/queue/waitCount';
  return get(url, { companyId: tenantId, sessionId: sessionId });
};

/**
 * 发送已读事件消息
 */
IMWebClient.read = function (params) {
  if (!IMWebClient?.session || !IMWebClient?.session?.sessionId) {
    console.error('IMWebClient 信息异常', IMWebClient.session);
    return;
  }
  let key = IM.KEY_CLIENT_MESSAGE_READ;
  let data = {
    tenantId: params.tenantId,
    sessionId: IMWebClient?.session?.sessionId,
    role: IM.role,
    sendMessageRole: params.sendMessageRole,
  };
  sendSentBody(key, data);
};

// 添加监听事件的函数
IMWebClient.on = function (eventType, handler) {
  if (!IMWebClient.listeners[eventType]) {
    IMWebClient.listeners[eventType] = []; // 如果该事件类型没有对应的监听器数组，则创建一个
  }
  IMWebClient.listeners[eventType].push(handler); // 将处理函数添加到监听器数组中
};
// 触发事件的函数
IMWebClient.trigger = function (eventType, ...args) {
  const handlers = IMWebClient.listeners[eventType];
  if (handlers) {
    // 如果存在事件类型对应的监听器数组，则依次调用每个处理函数
    handlers.forEach((handler) => {
      handler(...args);
    });
  }
};
// 清空监听事件的函数
IMWebClient.clearListeners = function () {
  // 遍历清空每个事件类型的监听器数组
  const eventTypes = Object.keys(IMWebClient.listeners);
  eventTypes.forEach((eventType) => {
    IMWebClient.listeners[eventType] = [];
  });
};
// 重置
IMWebClient.reset = function () {
  IMWebClient.clearListeners();
  IMWebClient.session = {};
  IMWebClient.bindCount = 0;
};

// 获取浏览器名称
function getBrowser() {
  let explorer = window.navigator.userAgent.toLowerCase();
  if (explorer.indexOf('msie') >= 0) {
    let ver = explorer.match(/msie ([\d.]+)/)[1];
    return { name: 'IE', version: ver };
  } else if (explorer.indexOf('firefox') >= 0) {
    let ver = explorer.match(/firefox\/([\d.]+)/)[1];
    return { name: 'Firefox', version: ver };
  } else if (explorer.indexOf('chrome') >= 0) {
    let ver = explorer.match(/chrome\/([\d.]+)/)[1];
    return { name: 'Chrome', version: ver };
  } else if (explorer.indexOf('opera') >= 0) {
    let ver = explorer.match(/opera.([\d.]+)/)[1];
    return { name: 'Opera', version: ver };
  } else if (explorer.indexOf('Safari') >= 0) {
    let ver = explorer.match(/version\/([\d.]+)/)[1];
    return { name: 'Safari', version: ver };
  }

  return { name: 'Other', version: '1.0.0' };
}

// uuid
function generateUUID() {
  let d = new Date().getTime();
  let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid.replace(/-/g, '');
}

export default IMWebClient;
